import { IconButton } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { PermissionActionType } from "@/constants/permissions"
import type { ProductAislesPreference } from "@/graphql/codegen/graphql"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface ProductAislesPreferenceListProps {
  aislesPreferences: ProductAislesPreference[]
  onEdit: (item: ProductAislesPreference) => void
}

const ProductAislesPreferencesTable: FC<ProductAislesPreferenceListProps> = ({ aislesPreferences, onEdit }) => {
  const { hasPermissions } = usePermissionManager()

  return (
    <table className='w-full border-0 text-sm'>
      <thead className='absolute size-0 overflow-hidden'>
        <tr>
          <th>Warehouse</th>
          <th>Aisles</th>
          {hasPermissions([PermissionActionType.WAREHOUSES_MAINTENANCE]) && <th>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {aislesPreferences.map((item) => (
          <tr key={item.productAislesPreferenceId} className='border-b border-gray-500'>
            <td className='h-[54px] w-1/2 pr-2.5 text-gray-900'>
              {item.warehouseArea?.externalSystemId} {item.warehouseArea?.location?.description} - {item.location}
            </td>
            <td className='pr-2.5'>{item.aisles.join(", ")}</td>
            {hasPermissions([PermissionActionType.WAREHOUSES_MAINTENANCE]) && (
              <td className='w-[40px]'>
                <IconButton color='primary' aria-label='Edit preferred aisles' onClick={() => onEdit(item)}>
                  <EditOutlined />
                </IconButton>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default ProductAislesPreferencesTable
